module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newScoring":"New scoring","editScoringModel":"Edit model"},"et":{"newScoring":"New scoring","editScoringModel":"Edit model"},"ru":{"newScoring":"New scoring","editScoringModel":"Edit model"}}')
  delete Component.options._Ctor
}
